




























































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Vehicle, ApiError, VehicleType } from '@/api';
import { snackModule, bookingModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import RelAutocomplete from '@/components/RelAutocomplete.vue';

@Component({
  components: {
    ConfirmDialog,
    RelAutocomplete,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  vehicle: Vehicle | null = null;

  makeSelect: string = '';
  colourSelect: string = '';

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredObject = [
    (v: VehicleType) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  get vehicleId() {
    return this.$route.params.vehicleId;
  }

  get makes() {
    const defaultMakes = bookingModule.makes;
    defaultMakes.push('Other');
    return defaultMakes;
  }
  get colours() {
    const defaultColours = bookingModule.colours;
    defaultColours.push('Other');
    return defaultColours;
  }

  vehicleTypeScopeFactory() {
    return VehicleType.includes([]).order({ name: 'asc' });
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.vehicle && this.vehicle.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.vehicle) {
      return;
    }

    if (this.vehicle.rego) {
      this.vehicle.rego = this.vehicle.rego.toUpperCase().replace(/\s/g, '');
    }

    if (this.makeSelect && this.makeSelect !== 'Other') {
      this.vehicle.make = this.makeSelect;
    }

    if (this.colourSelect && this.colourSelect !== 'Other') {
      this.vehicle.colour = this.colourSelect;
    }

    try {
      await this.vehicle.save();
      if (
        this.$route.name === 'admin-vehicles-add' &&
        this.vehicle &&
        this.vehicle.id
      ) {
        this.$router.push({
          name: 'admin-vehicles-edit',
          params: { vehicleId: this.vehicle.id },
        });
        snackModule.showSnackbar('Vehicle Created');
      } else {
        snackModule.showSnackbar('Vehicle Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.vehicleId) {
      try {
        this.vehicle = (
          await Vehicle.includes(['vehicleType', 'owner']).find(this.vehicleId)
        ).data;

        if (this.makes.includes(this.vehicle.make)) {
          this.makeSelect = this.vehicle.make;
        } else {
          this.makeSelect = 'Other';
        }

        if (this.colours.includes(this.vehicle.colour)) {
          this.colourSelect = this.vehicle.colour;
        } else {
          this.colourSelect = 'Other';
        }
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Vehicle not found');
      }
    }
  }
}
